import RenderTypeIcon from 'components/submissions-database/RenderTypeIcon';
import {
  DirectorIcon,
  GenreIcon,
  LoglineIcon,
  NotesIcon,
  PriorityIcon,
  ProducersIcon,
  ResponseStatusIcon,
  SubmittedByIcon,
  TitleIcon,
  WriterIcon
} from '../components/icons/icons';

export const headings = [
  {
    label: '',
    name: 'type',
    customHeadingClass: 'w-7 !pr-2'
  },
  {
    label: 'Title',
    name: 'title',
    sortable: true
  },
  {
    label: 'Writers/Directors/Producers',
    name: 'Writer/Directors/Producers'
  },
  {
    label: 'Submitted by',
    name: 'submittedBy'
  },
  {
    label: 'Genres',
    name: 'genre'
  },
  {
    label: 'Logline',
    name: 'logline'
  },
  {
    label: 'Note',
    name: 'note'
  },
  {
    label: 'Based on',
    name: 'based_on'
  },
  {
    label: 'Read',
    name: 'read',
    sortable: true
  },
  {
    label: 'Responded',
    name: 'response_status',
    sortable: true
  },
  {
    label: 'Priority',
    name: 'priority',
    sortable: true
  },
  {
    label: 'Date',
    name: 'created_at',
    sortable: true
  },
  {
    label: '',
    name: 'actions'
  }
];

const iconClass = '!inline-block !mr-3 !w-4';

export const filterItems = [
  {
    label: 'Company Name',
    value: 'company_name',
    icon: <TitleIcon className={iconClass} />
  },
  {
    label: 'Directors',
    value: 'directors',
    icon: <RenderTypeIcon className={iconClass} type={"directors"}/>
  },
  {
    label: 'Genres',
    value: 'genre',
    icon: <GenreIcon className={iconClass} />
  },
  {
    label: 'Priority',
    value: 'priority',
    icon: <PriorityIcon className={iconClass} />
  },
  {
    label: 'Producers',
    value: 'producers',
    icon:<RenderTypeIcon className={iconClass} type={"producers"}/>
  },
  {
    label: 'Read',
    value: 'read',
    icon: <PriorityIcon className={iconClass} />
  },
  {
    label: 'Response Status',
    value: 'response_status',
    icon: <ResponseStatusIcon className={iconClass} />
  },
  {
    label: 'Submitted By',
    value: 'submitted_by',
    icon: <SubmittedByIcon className={iconClass} />
  },
  {
    label: 'Type',
    value: 'type',
    icon: <LoglineIcon className={iconClass} />
  },
  {
    label: 'Writer',
    value: 'writer',
    
    icon: <RenderTypeIcon className={iconClass} type={"writer"}/>
  }
];

export const staticBooleanFiltersMapping = {
  response_status: {
    true: 'Responded',
    false: 'No Response'
  },
  read: {
    true: 'Read',
    false: 'Unread'
  }
};
